import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

type CheckBoxPropsType = {
  type: string;
};

export const StyledCheckbox = styled.div<CheckBoxPropsType>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  width: 24px;
  height: 24px;
  border-width: 1px;
  border-style: solid;
  border-color: ${themeGet('colors.input.checkbox')};
  border-radius: 2px;
  background-color: ${themeGet('colors.white')};
  transition: all 0.25s ease;

  ${(props) => props.type === 'secondary' && 'width: 18px; height: 18px;'}
`;

export const StyledContent = styled.span`
  cursor: pointer;
`;

export const StyledToggle = styled.div`
  touch-action: pan-x;
  position: relative;
  background-color: transparent;
  border: 0;
  padding: 0;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;

  display: flex;
  align-items: center;
  gap: 6px;

  &:hover {
    ${StyledCheckbox} {
      border-color: ${themeGet('colors.input.focus')};
    }
  }

  &.toggle--checked {
    ${StyledCheckbox} {
      border-color: ${themeGet('colors.input.focus')};
    }
  }

  &.middle {
    &.toggle--checked {
      ${StyledCheckbox} {
        background-color: ${themeGet('colors.primary.regular')};
        border-color: ${themeGet('colors.primary.regular')};
      }
    }
  }

  &.disabled {
    ${StyledCheckbox} {
      cursor: default;
      pointer-events: none;
      opacity: 0.35;
    }

    ${StyledContent} {
      cursor: default;
    }
  }

  b {
    color: ${themeGet('colors.text.default')};
  }
`;
